import React, {useContext, useState, useEffect} from 'react';
import CloseIcon from '@material-ui/icons/Close';
import Image from 'next/image';
import PuStackWhiteLogo from "../../../public/assets/images/logoDark.webp";
import PuStackLightLogo from "../../../public/assets/images/logo.webp";
import Lottie from 'lottie-react-web';
import { ThemeContext, PustackProContext } from "../../../context";
import Confetti from 'react-confetti';
import {SCHOLARSHIP} from '../../../helpers';
import ScholarshipSuccessLottie from '../../../public/assets/lottie/scholarship_success-1.json';

export default function AcceptedScreen({visible}) {
	const [isDark] = useContext(ThemeContext).theme;
	const [runConfetti, setRunConfetti] = useState(false);
	const [open ,setProSliderOpen] = useContext(PustackProContext).value;

	useEffect(() => {
		open && visible && setRunConfetti(true);
	}, [open, visible]);

	const handleClose = () => {
		setProSliderOpen(false);
	}

	return (
		<div className="successful-submission">
			<div
				className="close__wrapper"
				onClick={() => {
					handleClose();
					// setOrderStatus(false);
				}}
				style={{cursor: 'pointer'}}
			>
				<CloseIcon className="close__icon" />
			</div>
			<Confetti
				width={'700px'}
				// height={'1080px'}
				tweenDuration={10000}
				run={runConfetti}
				recycle={false}
				style={{ zIndex: 999 }}
				confettiSource={{ x: 0, y: 0, w: 350, h: 0 }}
			/>
			<Confetti
				width={'700px'}
				// height={'1080px'}
				tweenDuration={10000}
				run={runConfetti}
				recycle={false}
				style={{ zIndex: 999 }}
				confettiSource={{ x: 100, y: -300, w: 350, h: 500 }}
			/>
			<Confetti
				width={'700px'}
				// height={'1080px'}
				tweenDuration={10000}
				run={runConfetti}
				recycle={false}
				style={{ zIndex: 999 }}
				confettiSource={{ x: 650, y: 0, w: 350, h: 0 }}
			/>
			<div className="successful-submission-logo">
				<Image width={100} height={100} src={isDark ? PuStackWhiteLogo : PuStackLightLogo} alt="Pustack"/>
			</div>
			<div className="successful-submission-content">
				<Lottie
					style={{width: '70%'}}
					options={{
						animationData: ScholarshipSuccessLottie,
						loop: true,
					}}
				/>
				<h3>Congratulations</h3>
				<p>You have been granted the {SCHOLARSHIP.org_name} Scholarship!</p>
			</div>
			<button className="successful-submission-btn" onClick={() => {
				handleClose();
			}}>Done</button>
		</div>
	)
}
